export default {
  common: { all: '全部', yes: '是', no: '否' },
  actions: {
    publishTask: '发布任务', search: '查询', reset: '重置', view: '查看', edit: '编辑', withdraw: '撤回', resend: '重发',
    confirmWithdraw: '确认撤回', cancel: '取消', back: '返回', saveSchedule: '保存预约', saveDraft: '保存草稿',
    schedulePublish: '预约发布', publish: '发布', backToEdit: '返回修改', confirmSchedule: '确认预约',
    confirmPublish: '确认发布', close: '关闭', viewReceipt: '查看回执',
  },
  fields: {
    taskName: '任务名称', formType: '表单类型', department: '学部', grade: '年级', receiverRole: '接收角色',
    status: '任务状态', publishTime: '发布时间', deadline: '截止时间', completion: '完成情况', scope: '接收范围',
    operation: '操作', publishMode: '发布方式', scheduledPublishTime: '预约发布时间', publishDescription: '发布说明',
  },
  placeholders: {
    taskName: '请输入任务名称', startTime: '开始时间', endTime: '结束时间', autoTaskName: '例如：2026 学生注册资料收集',
    selectFormType: '请选择表单类型', selectDepartment: '请选择学部', selectGrade: '请选择年级（可多选）', noGradeRequired: '该学部未设置年级，无需选择',
    selectReceiverRole: '请选择接收角色',
    selectScheduledTime: '请选择预约发布时间', selectDeadline: '请选择截止时间',
    publishDescription: '例如：请在截止日期前核对资料并完成电子签署', studentName: '请输入学生姓名', studentNo: '请输入学生编号',
  },
  department: { kindergarten: '幼稚园', primary: '小学', secondary: '中学' },
  formType: { registration: '学生注册表', health: '健康申报表' },
  receiverRole: { parent: '家长', student: '学生', both: '家长、学生' },
  status: { draft: '草稿', scheduled: '预约发布', published: '已发布', ended: '已截止', withdrawn: '已撤回' },
  itemStatus: { pending: '待完成', completed: '已完成', incomplete: '未完成' },
  publishMode: { immediate: '立即发布', scheduled: '预约发布' },
  editor: {
    createTitle: '发布资料表任务', editTitle: '编辑资料表任务', steps: '填写任务信息 · 预览接收范围 · 确认发布',
    taskInfo: '任务信息', gradeMultiple: '年级（可多选）', estimatedStudents: '预计命中学生：', studentUnit: '人', systemGeneratedName: '由系统自动生成任务名称',
    publishNotice: '任务发布后可撤回；截止时间以服务器时间为准。同一学部和年级下，同一表单类型仅允许一个进行中的任务。',
    publishRuleTitle: '发布校验规则',
    publishRuleDescription: '同一学部、年级和表单类型只允许存在一个进行中的任务；如已有进行中任务，请先撤回或等待截止后再发布。',
  },
  validation: {
    taskNameLength: '任务名称最多 50 个字符', departmentRequired: '请选择学部', gradeRequired: '请至少选择一个年级',
    formTypeRequired: '请选择表单类型', receiverRoleRequired: '请至少选择一个接收角色',
    scheduledTimeRequired: '请选择预约发布时间', deadlineRequired: '请选择截止时间', futureTime: '时间必须晚于当前时间',
    scheduleBeforeDeadline: '预约发布时间必须早于截止时间', descriptionLength: '发布说明最多 200 个字符',
  },
  messages: {
    cannotWithdraw: '当前任务已不可撤回，请刷新列表后重试', withdrawTitle: '撤回任务？',
    withdrawDescription: '撤回后小程序不可再提交，已完成的提交回执会保留。', withdrawSuccess: '任务已撤回',
    resendTitle: '重新发布任务？', resendDescription: '将以原任务内容创建并立即发布一项新任务。', resendSuccess: '任务已重新发布，共生成 {count} 条学生任务',
    draftSaved: '草稿已保存', scheduleSaved: '预约设置已保存', noStudents: '当前范围没有可发布的学生',
    scheduleSuccess: '任务已预约发布', publishSuccess: '任务发布成功，共生成 {count} 条学生任务', loadDetailFailed: '任务详情加载失败',
  },
  confirm: {
    publishTitle: '确认发布任务？', scheduleTitle: '确认预约发布？',
    publishDescription: '发布后将按当前范围冻结学生名单和表单版本。',
    scheduleDescription: '到达预约时间后，服务端将按当前范围自动发布任务。',
  },
  states: { loading: '正在加载任务列表...', empty: '当前筛选条件下暂无任务' },
  stats: { target: '任务学生数量', completed: '已完成', pending: '待完成', incomplete: '未完成', withdrawnUnsubmitted: '撤回时未提交' },
  student: {
    studentName: '学生', studentNo: '学生编号', class: '年级/班级', seatNo: '班内号', submitter: '提交人',
    mobile: '提交手机号', completedTime: '提交时间',
  },
  submission: {
    title: '提交回执', submitter: '提交人', mobile: '提交手机号', submittedTime: '提交时间', confirmed: '电子确认',
    formVersion: '表单版本', formData: '提交内容', field: '字段', value: '内容', noData: '暂无提交内容',
  },
}
